(function () {
	console.clear();
	console.info('BMCBEC');
}());